import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { MetricDataList } from './metric-data-list.widget.model';

@Component({
    selector: 'cmps-widget-metric-data-list',
    templateUrl: './metric-data-list.widget.component.html',
})
export class MetricDataListWidgetComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    data: MetricDataList;

    constructor(
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {}

    ngOnInit(): void {
        this._sub = this._widgetService.dateRange.subscribe((dateRange) => {
            this.data = null;
            this.hasPendingData = true;
            this._service
                .metricDataList(this.config.definitionId)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        });
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }
}
